"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._getSpanForScope = _getSpanForScope;
exports._setSpanForScope = _setSpanForScope;

var _object = require("../utils-hoist/object.js");

const SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */

function _setSpanForScope(scope, span) {
  if (span) {
    (0, _object.addNonEnumerableProperty)(scope, SCOPE_SPAN_FIELD, span);
  } else {
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[SCOPE_SPAN_FIELD];
  }
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */


function _getSpanForScope(scope) {
  return scope[SCOPE_SPAN_FIELD];
}